import { useEffect, useState, useRef } from 'react';
import debounce from 'lodash/debounce';

const usePageOffset = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [topOffset, setTopOffset] = useState(0);

  const calculatePageOffset = () => setTopOffset(containerRef.current?.offsetTop ?? 0);

  useEffect(() => {
    const debouncedHandler = debounce(calculatePageOffset, 200);

    calculatePageOffset();
    window.addEventListener('resize', debouncedHandler);

    return () => {
      window.removeEventListener('resize', debouncedHandler);
    };
  }, []);

  return {
    containerRef,
    topOffset: `${ topOffset }px`,
  };
};

export default usePageOffset;
